import { ClientDto } from '../../../../api';
import useFormStyles from './../../../../styles/useFormStyles';
import { useForm, FormProvider } from 'react-hook-form';
import { Button, Grid } from '@mui/material';
import { TextField } from './../../../../components/form/react-hook-form-components/';

interface IClientFormProps {
  client?: ClientDto;
  onSubmit: (values: ClientDto) => void;
  onCancel: () => void;
  clientNameSuggestion?: string;
}

/**
 * The form for creating and updating clients.
 */
function ClientForm(props: IClientFormProps) {
  const classes = useFormStyles();
  const { client, onSubmit, onCancel, clientNameSuggestion } = props;
  const methods = useForm<ClientDto>({
    defaultValues: { id: client?.id, name: client?.name ?? clientNameSuggestion },
  });
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            <TextField name="name" label="Client Name" required autoFocus />
          </Grid>
          <Grid item container direction={'row'} justifyContent="end" spacing={1}>
            <Grid item>
              <Button variant="contained" size="large" className={classes.submitButton} type="submit">
                {client ? 'Update' : 'Create'}
              </Button>
            </Grid>
            <Grid item>
              <Button variant="outlined" size="large" color="neutral" onClick={onCancel}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
}

export default ClientForm;
